import { render, staticRenderFns } from "./PaymentSwitch.vue?vue&type=template&id=473cdb1f&scoped=true&"
import script from "./PaymentSwitch.vue?vue&type=script&lang=js&"
export * from "./PaymentSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSwitch.vue?vue&type=style&index=0&id=473cdb1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473cdb1f",
  null
  
)

export default component.exports